// import React, { useState, useEffect } from "react";
// import { FiPlus } from "react-icons/fi";
// import { RxCross1, RxCross2 } from "react-icons/rx";
// import Select, { components } from "react-select";
// import { platformOptions, platformIcons } from "./socialCalendarConstants";
// import SocialDialog from "./SocialDialog";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import { useSelector } from "react-redux";

// const SelectPlatformContent = ({
//   onClose,
//   values,
//   setFieldValue,
//   editedPlatforms,
// }) => {
//   const [selectedPlatforms, setSelectedPlatforms] = useState([]);
//   const { platformList } = useSelector((state) => state.api);

//   useEffect(() => {
//     editedPlatforms?.length && setSelectedPlatforms(editedPlatforms);
//   }, [editedPlatforms]);

//   const handleApply = () => {
//     setFieldValue("platforms", selectedPlatforms);
//     onClose();
//   };
//   return (
//     <div>
//       <p className="text-xs mb-1">List of Platforms</p>
//       <Select
//         isMulti
//         options={platformList}
//         className="text-xs"
//         placeholder="Select Platform"
//         value={selectedPlatforms}
//         components={{
//           SingleValue: ({ data }) => <>{platformIcons[data.value]}</>,
//           MultiValue: ({ data, removeProps }) => (
//             <div className="flex items-center mr-[1px] space-x-1  px-2 py-1 rounded-md">
//               {platformIcons[data.value]}
//               <span
//                 {...removeProps}
//                 className="text-gray-500 cursor-pointer p-1 rounded hover:text-white hover:bg-red-300"
//               >
//                 <RxCross1 />
//               </span>
//             </div>
//           ),
//         }}
//         onChange={(selectedOptions) => setSelectedPlatforms(selectedOptions)}
//       />

//       {selectedPlatforms.length > 0 && (
//         <div className="flex justify-center text-xs gap-4 mt-4">
//           {selectedPlatforms.map((option, index) => (
//             <div key={index}>{platformIcons[option.value]} </div>
//           ))}
//         </div>
//       )}
//       <div className="w-full mt-4  flex justify-end">
//         <button
//           className="btn-1 w-[fit-content] text-xs font-normal bg-blue-600 text-white py-2 rounded-[5px]"
//           onClick={handleApply}
//         >
//           Apply
//         </button>
//       </div>
//     </div>
//   );
// };

// const SelectPlatforms = ({ values, setFieldValue, editedPost }) => {
//   const [openPlatformDialog, setOpenPlatformDialog] = useState(false);
//   const { platformList } = useSelector((state) => state.api);
//   const [editedPlatforms, setEditedPlatforms] = useState([]);

//   useEffect(() => {
//     if (editedPost?.platforms?.length && platformList?.length) {
//       const platformNameArr = editedPost.platforms.map(
//         (item) => item.platformName
//       );
//       let selectedPlatforms = platformList.filter((item) =>
//         platformNameArr.includes(item.value)
//       );
//       setEditedPlatforms(selectedPlatforms);
//       setFieldValue("platforms", selectedPlatforms);
//     }
//   }, [editedPost, platformList]);

//   return (
//     <div>
//       <h1 className="font-bold text-sm">Platform Selection</h1>
//       <div className="flex items-center text-3xl py-3 gap-3">
//         {values?.platforms?.map((platform, index) => (
//           <div key={index}>{platformIcons[platform.value]}</div>
//         ))}
//         <span
//           onClick={() => setOpenPlatformDialog(true)}
//           className="add-platform transition border-[2px] hover:text-white hover:bg-[#E6F7FF]  border-dotted hover:border-solid border-opacity-20 hover:border-opacity-20 hover:border-[#007aff] hover:-translate-y-1 duration-700 ease-in-out bg-[#e6f7ff] p-2 cursor-pointer"
//         >
//           <FiPlus className="text-sm text-[#007aff] " />
//         </span>
//         <SocialDialog
//           isOpen={openPlatformDialog}
//           onClose={() => setOpenPlatformDialog(false)}
//           title={"Platform List"}
//           content={
//             <SelectPlatformContent
//               onClose={() => setOpenPlatformDialog(false)}
//               platforms={values.platforms}
//               // setPlatforms={setSelectedPlatforms}
//               values={values}
//               setFieldValue={setFieldValue}
//               editedPlatforms={editedPlatforms}
//             />
//           }
//         />
//       </div>
//       <ErrorMessage
//         name="platforms"
//         component="p"
//         className="text-red-500 text-xs mt-1"
//       />
//     </div>
//   );
// };

import React, { useState } from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa";


const platformOptions = [
  {
    value: "Facebook",
    label: "Facebook",
    icon: <FaFacebook />,
    color: "text-blue-600",
  },
  {
    value: "Instagram",
    label: "Instagram",
    icon: <FaInstagram />,
    color: "text-pink-500",
  },
];

const SelectPlatforms = ({ values, setFieldValue, editable }) => {
  const [selectedPlatforms, setSelectedPlatforms] = useState(() => {
    return platformOptions.filter((option) =>
      values.platforms?.some((p) => p.platformName === option.value)
    );
  });

  const handleToggle = (platform) => {
    const isSelected = selectedPlatforms.find(
      (p) => p.value === platform.value
    );
    const updated = isSelected
      ? selectedPlatforms.filter((p) => p.value !== platform.value)
      : [
          ...selectedPlatforms,
          { label: platform.value, value: platform.value },
        ];

    setSelectedPlatforms(updated);
    setFieldValue("platforms", updated);
  };
  return (
    <div>
      <h1 className="font-bold text-sm mb-2">Platform Selection</h1>
      <div className="flex gap-2">
        {platformOptions.map((platform) => {
          const isSelected = selectedPlatforms.some(
            (p) => p.value === platform.value
          );
          return (
            <button
              key={platform.value}
              className={`cursor-pointer p-1.5 rounded-full transition border-2 flex items-center justify-center
                ${
                  isSelected ? "border-blue-500 bg-blue-100" : "border-gray-200"
                }
              `}
              disabled={!editable}
              onClick={() => handleToggle(platform)}
              title={platform.label}
              style={{ width: 48, height: 48 }}
            >
              <div className={`text-[28px] ${platform.color}`}>
                {platform.icon}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SelectPlatforms;
